<div class="modal-body modal-body-info">
  <img class="icon" src="assets/images/new-design-icons/check-ready.svg">
  <div class="info-modal-title"> {{ title }}</div>
  <div class="info-modal-subtitle">{{ subtitle }}</div>
  <app-button [buttonClass]="'big-gray-light'" [text]="'Закрыть окно'" (buttonClick)="closePanel.emit(false)" [styleInline]="{'width': '100%'}"></app-button>
</div>